import React, { useEffect, useRef, useState } from "react";
import "./terminalmodal.css"
import { t } from "i18next";
import { useTranslation } from "react-i18next";

interface TerminalModalProps {
  open: boolean;
  onClose: () => void;
}

const announcementsList = [
  {
    date: "2025-05-05",
    message: "Welcome to Milkit. The contracts were deployed today.",
  },
  {
    date: "2025-05-11",
    message: "Initial Liquidity added to the pool.",
  },
    {
      date: "2025-05-12",
      message: "1000 Followers on X.",
    },
    {
      date: "2025-05-12",
      message: "Game is now live.",
    },
    {
      date: "2025-05-12",
      message: "FeeM integration.",
    },
    {
      date: "2025-05-13",
      message: "Leaderboard is now live.",
    },
    {
      date: "2025-05-14",
      message: "Snake Finance Partnership Flex Item.",
    },
    {
      date: "2025-05-14",
      message: "Hand of God Partnership Flex Item.",
    },
    {
      date: "2025-05-14",
      message: "Shadow Partnership Flex Item.",
    },
    {
      date: "2025-05-15",
      message: "1M MILK burned.",
    },
];

const TerminalModal: React.FC<TerminalModalProps> = ({ open, onClose }) => {
  const { t, i18n } = useTranslation();
  // MODAL OPEN AND CLOSE
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div data-state="open" className="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" style={{ pointerEvents: "auto" }} data-aria-hidden="true" aria-hidden="true">
      <div
        ref={modalRef}
        role="dialog"
        id="radix-:r4f:"
        aria-describedby="radix-:r4h:"
        aria-labelledby="radix-:r4g:"
        data-state="open"
        className="text-sm fixed left-[50%] top-[50%] z-50 grid w-full max-w-modal translate-x-[-50%] translate-y-[-50%] gap-4 border border-slate-200 p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg dark:border-slate-800 dark:bg-slate-950 bg-primary text-white"
        tabIndex={-1}
        style={{ pointerEvents: "auto", border: "none", background: "rgb(16, 44, 57)" }}
      >
        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
        <h2 className="sc-8a96375e-3 jmoGw">{t("terminal.title")}</h2>
        <div className="sc-8a96375e-0 iUfIIC">
          {announcementsList.map((announcement, index) => (
            <div key={index} className="sc-8a96375e-1 ceDvuC" style={{ textAlign: "left", lineHeight: "1.5em" }}>
              <span className="sc-8a96375e-2 cvCUeV">[{announcement.date}]</span>
              {announcement.message}
            </div>
          ))}
        </div>
        <button className="sc-cdc39d4e-0 sc-8a96375e-4 gvrgXY cjAZfS" onClick={onClose}>
          {t("terminal.close")}
        </button>
        </div>
      </div>
    </div>
  );
}
export default TerminalModal;